import { getJsonOrError } from '../../utils/fetch'
import {
  getPostActionsPath,
  getPostActionsFromPdo as getActionsFromPdo,
  getPostAuthorId,
} from '../../application/pageDataObject'
import { CurrentUser } from '../../providers/currentUser'

const postActionsUrl = `${location.protocol}${getPostActionsPath()}`

export async function getPostActions(postId) {
  const adminOptionsPathByPost = `${postActionsUrl}/${postId}`
  return await getJsonOrError(adminOptionsPathByPost, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'charset=utf-8',
    },
  })
}

export async function getPostActionsFromPdo() {
  const currentUser = new CurrentUser()
  const userRole = currentUser.getRole(getPostAuthorId())

  if (userRole) {
    return formatPostActionsResult(userRole)
  }
}

function formatPostActionsResult(userRole) {
  const postActionsHash = getActionsFromPdo()
  return userRole ? { data: { options: postActionsHash[userRole] } } : { data: { options: [] } }
}

export const confirmAdminAction = action => {
  const confirmationText = `Really ${action.text} this post ?`
  return confirm(confirmationText)
}

export async function sendServerAdminAction(action) {
  return await getJsonOrError(action.url, {
    credentials: 'include',
    method: 'POST',
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/postActions/postActionsProvider.js